import { render, staticRenderFns } from "./SubjectTitledBox.vue?vue&type=template&id=2121a857&scoped=true&lang=pug&"
import script from "./SubjectTitledBox.vue?vue&type=script&lang=ts&"
export * from "./SubjectTitledBox.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectTitledBox.vue?vue&type=style&index=0&id=2121a857&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121a857",
  null
  
)

export default component.exports